//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2026 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------
export default {
  name: 'keyword',
  props: {
    isDisabled: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    labelarr: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    type: {
      type: String,
      default: function _default() {
        return 'text';
      }
    }
  },
  data: function data() {
    return {
      val: ''
    };
  },
  methods: {
    labelhandleClose: function labelhandleClose(tag) {
      if (this.isDisabled) return;
      var index = this.labelarr.indexOf(tag);
      this.labelarr.splice(index, 1);
    },
    addlabel: function addlabel() {
      var count = this.labelarr.indexOf(this.val);
      if (count === -1) {
        this.labelarr.push(this.val);
      }
      this.val = '';
      this.$emit('getLabelarr', this.labelarr);
    }
  }
};